import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { BehaviorCache } from 'src/lib/utilities/cache';
import { CurriculumMappingSectionOptionsModel } from '../../api/organizations/teachers/curriculum-mapping/curriculum-mapping-section.model';
import { CurriculumMappingService } from '../../api/organizations/teachers/curriculum-mapping/curriculum-mapping.service';

@Injectable({
	providedIn: 'root',
})
export class CurriculumMappingStoreService {
	private _sectionOptionsCache = new BehaviorCache<
		1,
		CurriculumMappingSectionOptionsModel
	>(
		() => this.curriculumMappingService.getSectionOptions(),
		'CurriculumMappingStoreService SectionOptionsCache',
	);

	constructor(private curriculumMappingService: CurriculumMappingService) {}

	public sectionOptions$ =
		(): Observable<CurriculumMappingSectionOptionsModel> => {
			return this._sectionOptionsCache.getCache(1).pipe(
				map((result) => {
					result.assert();
					return result.value;
				}),
				catchError((error) => {
					this._sectionOptionsCache.clearData(1);
					return throwError(() => error);
				}),
			);
		};

	public refreshSectionOptions = (): Promise<boolean> => {
		return this._sectionOptionsCache.fetchData(1, true);
	};
}
